var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('div',{staticClass:"d-flex align-center"},[_c('h1',[_vm._v(_vm._s(_vm.welcomeMessage))])])]),_c('v-main',[_c('main-page')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }